// Internal AIcrowd design-system module — NOT an npm package. Imported by
// admin-authored React components running inside DynamicComponentRenderer.
// The renderer's `customRequire` maps the bare specifier 'aicrowd-ui' to
// this module's exports.

export { default as BannerLayout } from './BannerLayout';
export { gql } from './gql';

export { useSubmission, SubmissionError, QuotaExceededError, RoundLockedError, RestrictedIpError, RulesNotAcceptedError } from './hooks/useSubmission';
export type { SubmissionStatus, SubmissionPayload, SubmitOptions } from './hooks/useSubmission';
export { useQuota } from './hooks/useQuota';
export type { QuotaState } from './hooks/useQuota';
export { useRound } from './hooks/useRound';
export type { RoundState } from './hooks/useRound';
export { useViewerEntry } from './hooks/useViewerEntry';
export type { ViewerEntry } from './hooks/useViewerEntry';
export { useRegistration, RegistrationError } from './hooks/useRegistration';
export type { RegistrationStatus, RegisterArgs, RegistrationResult } from './hooks/useRegistration';
export { useSelection, SelectionError } from './hooks/useSelection';
export type { SelectionStatus, SelectionContext } from './hooks/useSelection';
export { useQuery } from './hooks/useQuery';
export type { UseQueryArgs, UseQueryResult, QueryStatus } from './hooks/useQuery';
export { useNow } from './hooks/useNow';
export { relTime } from './formatters/relTime';
export * from './identity';

export { default as CodeEditor } from './CodeEditor';
export type { CodeEditorProps, CodeEditorHandle, CodeLanguage } from './CodeEditor';
